"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
const ReducerRegistry_1 = require("@dialogexe/cw-website-store/ReducerRegistry");
const reducerCreator_1 = require("./state/reducerCreator");
const metadata = require('./metadata.json');
class SearchField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            keyword: ''
        };
    }
    componentWillMount() {
        ReducerRegistry_1.default.register(metadata.state.name, reducerCreator_1.reducerCreator({
            keyword: '',
            results: { arrangements: {}, news: [], tickets: [] },
            arrangements: this.props.arrangements,
            tickets: this.props.tickets,
            news: this.props.news,
        }));
    }
    componentDidMount() {
        const query = this.getQueryParam();
        if (query) {
            this.setState({ keyword: query });
            this.props.search(query);
        }
    }
    render() {
        return (React.createElement("div", { className: "SearchField" },
            React.createElement("i", { className: "icon is-large" },
                React.createElement("img", { src: icons_1.searchBigIcon, alt: "" })),
            React.createElement("input", { className: "input", placeholder: "S\u00F8k", type: "text", value: this.state.keyword, onChange: this.handleInputChange.bind(this) })));
    }
    handleInputChange(e) {
        const keyword = e.target.value;
        this.setState({ keyword });
        this.props.search(keyword);
    }
    getQueryParam() {
        let query = null;
        if (typeof window !== 'undefined') {
            const url = new URL(window.location.href);
            query = url.searchParams.get('query');
        }
        return query;
    }
}
exports.SearchField = SearchField;
exports.default = react_redux_1.connect(null, (dispatch) => ({
    search: (keyword) => dispatch({ type: 'search', keyword })
}))(SearchField);



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-search-field/SearchField.tsx